"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicInfrastructure = void 0;
var CardName_1 = require("../../CardName");
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("../prelude/PreludeCard");
var TileType_1 = require("../../TileType");
var CardRenderer_1 = require("../render/CardRenderer");
var PlaceMoonRoadTile_1 = require("../../moon/PlaceMoonRoadTile");
var BasicInfrastructure = (function (_super) {
    __extends(BasicInfrastructure, _super);
    function BasicInfrastructure() {
        return _super.call(this, {
            name: CardName_1.CardName.BASIC_INFRASTRUCTURE,
            tags: [Tags_1.Tags.MOON],
            metadata: {
                description: 'Place a road tile on the Moon and raise the Logistics Rate 1 step. Gain 1 trade fleet.',
                cardNumber: '',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tile(TileType_1.TileType.MOON_ROAD, false).tradeFleet();
                }),
            },
        }) || this;
    }
    ;
    BasicInfrastructure.prototype.play = function (player) {
        player.game.defer(new PlaceMoonRoadTile_1.PlaceMoonRoadTile(player));
        player.increaseFleetSize();
        return undefined;
    };
    return BasicInfrastructure;
}(PreludeCard_1.PreludeCard));
exports.BasicInfrastructure = BasicInfrastructure;
//# sourceMappingURL=BasicInfrastructure.js.map